import { render, staticRenderFns } from "./booksCarousel.vue.html?vue&type=template&id=0ccc29ed&"
import script from "./booksCarousel.ts?vue&type=script&lang=ts&"
export * from "./booksCarousel.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports